<template>
  <v-container fluid>
    <v-row>
      <v-col cols="2">
        <v-card>
          <v-toolbar color="primary" flat dark dense>
            <v-toolbar-title class="ml-2">Reports</v-toolbar-title>
          </v-toolbar>
          <v-list dense>
            <v-list-item-group v-model="item" color="primary">
              <v-list-item v-for="(item, i) in items" :key="i" @click="selectReport(item)">
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="10">
        <report-input
          v-model="reportInput"
          :allow-query-execution="!queryRunning"
          :available-inputs=reportComponentInputs
          :supports-html-report="htmlReportSupport"
          :supports-csv-report="csvReportSupport"
          :supports-excel-report="excelReportSupport"
        ></report-input>

        <v-sheet
          v-show="queryRunning"
          color="grey lighten-4"
          class="px-3 pt-3 pb-3"
        >
          <v-skeleton-loader
            class="mx-auto"
            type="card"
          ></v-skeleton-loader>
        </v-sheet>

        <component
          v-show="hasReportInput"
          v-bind:is="reportViewCard"
          v-bind="reportInput"
          :run-report="queryRunning"
          v-on:report-complete="onReportComplete"
          v-on:close-report="onReportClose"
          class="mt-4"
        ></component>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import { mapState } from 'vuex'
import ReportInput from '@/components/reports/inputs/ReportInput'
import { isEmpty, pathOr } from 'ramda'
import DealerRoReport from '@/components/reports/views/DealerRoReport'
import CampaignSummaryReport from '@/components/reports/views/CampaignSummaryReport'
import CampaignRoiReport from '@/components/reports/views/CampaignRoiReport'
import EmailResponseReport from '@/components/reports/views/EmailResponseReport'
import SalesServiceByPostalCodeReport from '@/components/reports/views/SalesServiceByPostalCodeReport'

export default {
  name: 'reports',
  components: {
    [ReportInput.name]: ReportInput,
    [DealerRoReport.name]: DealerRoReport,
    [CampaignSummaryReport.name]: CampaignSummaryReport,
    [CampaignRoiReport.name]: CampaignRoiReport,
    [EmailResponseReport.name]: EmailResponseReport,
    [SalesServiceByPostalCodeReport.name]: SalesServiceByPostalCodeReport
  },
  data: function () {
    return {
      item: 0,
      items: [
        { text: 'Dealer RO Report',
          icon: 'mdi-car-3-plus',
          component: DealerRoReport.name,
          excelReportSupport: true
        },
        { text: 'Campaign Performance Summary',
          icon: 'mdi-folder-table',
          component: CampaignSummaryReport.name,
          reportInputComponents: ['campaign-select-input'],
          htmlReportSupport: false,
          excelReportSupport: true },
        { text: 'Campaign ROI Report',
          icon: 'mdi-cash-multiple',
          component: CampaignRoiReport.name,
          reportInputComponents: ['campaign-select-input'],
          htmlReportSupport: false,
          csvReportSupport: true,
          excelReportSupport: true
        },
        { text: 'Email Response Report',
          icon: 'mdi-email-newsletter',
          component: EmailResponseReport.name,
          reportInputComponents: ['email-response-input'],
          htmlReportSupport: true,
          excelReportSupport: true
        },
        { text: 'Sales and Service by Postal Code',
          icon: 'mdi-mailbox',
          component: SalesServiceByPostalCodeReport.name,
          reportInputComponents: ['report-start-end-customer_type-input'],
          htmlReportSupport: true,
          excelReportSupport: true
        }
      ],
      reportInput: {},
      queryRunning: false,
      currentReport: {}
    }
  },
  computed: {
    ...mapState('DealerStore', ['dealer']),
    reportViewCard () {
      return this.currentReport.component
    },
    reportComponentInputs () {
      return this.currentReport.reportInputComponents
    },
    hasReportInput () {
      return !isEmpty(this.reportInput) && this.reportInput.outputFormat === 'html' && !this.queryRunning
    },
    htmlReportSupport () {
      return pathOr(true, ['htmlReportSupport'], this.currentReport)
    },
    csvReportSupport () {
      return pathOr(true, ['csvReportSupport'], this.currentReport)
    },
    excelReportSupport () {
      return pathOr(false, ['excelReportSupport'], this.currentReport)
    }
  },
  watch: {
    dealer () {
      this.reportInput = {}
    },
    reportInput (newVal, oldVal) {
      // if (!isEmpty(newVal)) {
      this.queryRunning = !isEmpty(newVal)
    }
  },
  methods: {
    selectReport (reportDetail) {
      this.$logger.trace('switching report', reportDetail)
      this.currentReport = reportDetail
    },
    onReportComplete (evt) {
      this.queryRunning = false
      if (evt.status === 'error') {
        this.$flash({
          showClose: true,
          message: `Error loading report: ${evt.message}`,
          type: 'error',
          duration: 0
        })
      }
    },
    onReportClose (evt) {
      this.reportInput = {}
    }
  },
  mounted () {
    this.selectReport(this.items[0])
  }
}
</script>
